import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lobby from '../elimination-lobby/eliminationLobby';
import EliminationGame from '../elimination-game/eliminationGame';
import ContentSwapper from '../content-swapper/contentSwapper';
import GameEndElimination from '../elimination-end/gameEndElimination';
import openSocket from 'socket.io-client';

import './eliminationMode.css';


class EliminationMode extends Component {

  constructor(props) {
    super(props);

    this.startGame = this.startGame.bind(this);
    this.beginNewLobby = this.beginNewLobby.bind(this);
    this.submitPlayerAnswer = this.submitPlayerAnswer.bind(this);
    this.resetAnswerCount = this.resetAnswerCount.bind(this);
    this.endGame = this.endGame.bind(this);
    
    this.socket = openSocket('http://web.hlg2.computerlove.co.uk', {
      transports: ['websocket']
    });
    
    // on reconnection, reset the transports option, as the Websocket
    // connection may have failed (caused by proxy, firewall, browser, ...)
    this.socket.on('reconnect_attempt', () => {
      this.socket.io.opts.transports = ['polling', 'websocket'];
    });

    this.state = { 
      multiplayerGamesPlayed: 0,
      playerCount: 1, 
      playerName: this.socket.id,
      lobbyReady: false,
      gameState: 'lobby',
      higherCount: 0,
      lowerCount: 0
    }
  }

  componentDidMount() {
    this.beginNewLobby();

    this.setState((prevState, props) => ({
      multiplayerGamesPlayed: prevState.multiplayerGamesPlayed + 1
    }));
  }

  shouldShowAd() {
    let onDesktop = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 500;
    let notFirstMultiplayerGame = this.state.multiplayerGamesPlayed !== 0;
    return onDesktop && notFirstMultiplayerGame;
  }

  startGame() {
    this.setState({ gameState: 'in_progress' });
  }

  submitPlayerAnswer(answer) {
    this.socket.emit('answer_submitted', {answer: answer});
  }

  resetAnswerCount() {
    this.setState({
      higherCount: 0,
      lowerCount: 0
    });
  }

  endGame(roundPlayerCount) {
    this.socket.emit('leave_room');

    this.setState((prevState, props) => ({
      gameState: 'end',
      roundPlayerCount: roundPlayerCount
    }));
  }

  beginNewLobby() {
    this.setState({ 
      gameState: 'lobby', 
      playerCount: 1, 
      lobbyReady: false,
      higherCount: 0,
      lowerCount: 0
    });

    this.socket.off('player_joined');
    this.socket.off('player_left');
    this.socket.off('game_init');
    this.socket.off('player_answered');

    this.socket.on('player_joined', data => {
      this.setState({
        playerCount: data.playerCount, 
        roundPlayerCount: data.playerCount,
        roomName: data.roomName.replace('hlg-', '')
      });
    });

    this.socket.on('player_left', data => {

      if (data.playerCount === 1) {
        this.socket.emit('leave_room');
        this.setState({
          playerCount: data.playerCount,
          roundPlayerCount: 1,
          playerName: data.playerName,
          gameState: 'end'
        });

        return;
      }

      this.setState({
        playerCount: data.playerCount,
        playerName: data.playerName
      });
    });

    this.socket.on('game_init', data => {
      this.setState({
        totalPlayerCount: this.state.playerCount,
        lobbyReady: true, 
        terms: data.terms
      });
    });

    this.socket.on('player_answered', data => {
      this.setState((prevState, props) => ({
        higherCount: data.answer === 'higher' ? prevState.higherCount + 1 : prevState.higherCount,
        lowerCount: data.answer === 'lower' ? prevState.lowerCount + 1 : prevState.lowerCount
      }));
    });

    setTimeout(() => {
      this.socket.emit('join_room');
    }, 300);
  }

  renderLobby() {
    return (<Lobby 
      startGame={this.startGame} 
      showAd={this.shouldShowAd()} 
      playerCount={this.state.playerCount} 
      roomName={this.state.roomName}
      lobbyReady={this.state.lobbyReady} />);
  }

  render() {
    if (this.state.gameState === 'lobby') {
      return this.renderLobby();
    }
    return (
      <ContentSwapper swap={this.state.gameState === 'end'}>
        <EliminationGame 
          pack={this.props.pack} 
          terms={this.state.terms} 
          onPlayerAnswered={this.submitPlayerAnswer}
          onRoundLost={this.endGame}
          onRoundWon={this.resetAnswerCount} 
          playerCount={this.state.playerCount}
          totalPlayerCount={this.state.totalPlayerCount}
          timeLimitSeconds={10} 
          remoteHigherCount={this.state.higherCount} 
          remoteLowerCount={this.state.lowerCount} />
        <GameEndElimination  
          score={this.state.roundPlayerCount} 
          playerCount={this.state.totalPlayerCount} 
          playAgainHandler={this.beginNewLobby}
          exitGameHandler={this.props.onQuitGame} />
      </ContentSwapper>
    );
  }
}

export default EliminationMode;

EliminationMode.propTypes = {
  pack: PropTypes.string,
  onQuitGame: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/elimination-mode/eliminationMode.js